var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcDocumentLeftArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 14.25H11.1225L13.0575 12.3075L12 11.25L8.25 15L12 18.75L13.0575 17.6925L11.1225 15.75H21V14.25Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 10.5V7.50001C18.0006 7.40131 17.9817 7.30346 17.9443 7.21208C17.907 7.1207 17.852 7.03759 17.7825 6.96751L12.5325 1.71751C12.4624 1.648 12.3793 1.59301 12.2879 1.55568C12.1966 1.51836 12.0987 1.49944 12 1.50001H4.5C4.10218 1.50001 3.72064 1.65805 3.43934 1.93935C3.15804 2.22066 3 2.60219 3 3.00001V21C3 21.3978 3.15804 21.7794 3.43934 22.0607C3.72064 22.342 4.10218 22.5 4.5 22.5H16.5C16.8978 22.5 17.2794 22.342 17.5607 22.0607C17.842 21.7794 18 21.3978 18 21V19.5H16.5V21H4.5V3.00001H10.5V7.50001C10.5 7.89784 10.658 8.27937 10.9393 8.56067C11.2206 8.84198 11.6022 9.00001 12 9.00001H16.5V10.5H18ZM12 7.50001V3.30751L16.1925 7.50001H12Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDocumentLeftArrow);
export default __webpack_public_path__ + "static/media/ic-document-left-arrow.67fe484cdc01b94e6af65439457637ed.svg";
export { ForwardRef as ReactComponent };